import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CoreService } from 'src/app/core/services/core.service';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'bs-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent implements OnInit {

  public articleData: any;
  public article: any;
  public carouselData: any = {items: []};

  constructor(
    private http: HttpClient,
    public coreService: CoreService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta,
  ) { }

  ngOnInit() {
      this.activatedRoute.params.subscribe(
        params => {
          this.coreService
          .fetchData(`articles/${params['id']}`)
          .subscribe((article: any) => {
            if (article.image) {
              ['og:image', 'twitter:image'].forEach((x) => this.metaService.updateTag({
                name: x,
                content: this.coreService.getCompressedImage(article.image.data.url)
              }));
              this.carouselData.items = [{
                image: this.coreService.getCompressedImage(article.image.data.url),
                mobileImage: article.mobileImage ? this.coreService.getCompressedImage(article.mobileImage.data.url) : null,
                imageBackgroundPosition: article.imageBackgroundPosition,
                video: article.video ? article.video.data.url : '',
                mobileImageBackgroundPosition: article.mobileImageBackgroundPosition,
              }];
            }
            this.articleData = article;
            if (article.body) {
              this.article = this.coreService.generateBody(article.body);
            }
            this.titleService.setTitle(`${article.title} - British Shooting`);
            ['og:title', 'twitter:title'].forEach((x) => this.metaService.updateTag({
              name: x,
              content: `${article.title} - British Shooting`
            }));
            ['description', 'og:description', 'twitter:description'].forEach((x) => this.metaService.updateTag({
              name: x,
              content: article.description
                ? article.description
                : article.body
                    .replace(/<\/?[^>]+(>|$)/g, '')
                    .substring(0, 160)
                    .replace(/(^|\s)\S*$/, '')
                    .trim(),
            }));
          });
        }
      );
  }

}
